import { createRoutesFromElements, Route } from "react-router-dom";
import {
	LoginGuard,
	AuthGuard,
	VisitorGuard,
} from "@/apps/liff/layouts";
import { AdminLoginGuard } from "@/apps/backend/layouts";
import { BindingActionGuard } from "./apps/liff/layouts";
import { EcLayout } from "@/apps/liff/layouts";
import { MgmGuard } from "./apps/liff/layouts";

import {
	ProfilePage,
	ProfilePageError1,
	ProfilePageError2,
	BindingPage,
	ThanksPage,
	CouponWalletPage,
	CouponWalletPageEmpty,
	DesktopPage,
	BindingSalesPage,
	TbGameRedirectPage,
	ShareModulePage,
	ShareToFriendsPage,
	LineOAuthPage,
	NpsPage,
	CampaignCouponPage,
	EcSeriesProductPage,
	EcCollectPage,
	EcProductPage,
	EcSeriesPage,
	Splash2026Page,
  WallPaperStartPage,
  WallPaperLayoutPage,
  WallpaperTextSettingPage,
  WallpaperProviders,
  WallpaperSharePage,
  WallpaperLiffPage,
  WallpaperIntlPage,
  WallpaperLogLoginGuard,
  WallpaperDownloadPage,
  WallpaperViewPage,
} from "@/apps/liff/pages";
import { ExamplePage } from "@/apps/backend/pages";
import { PgLoginGuard, PgLoginPage, PgHomePage, PgScanPage } from "@/apps/pg";
import { LogisticsPage } from "@/apps/liff/pages/logistics-page";
import { LogisticsListPage } from "@/apps/liff/pages/logistics-list-page";
import { VipStatementPage } from "@/apps/liff/pages/vip-statement-page";

const routes = createRoutesFromElements(
	<Route>
		<Route path="/admin" element={<AdminLoginGuard />}>
			<Route index element={<ExamplePage />} />
		</Route>
		{/* PG 現場兌換：獨立帳號登入，不走 LIFF（連結 /pg/{活動代碼}） */}
		<Route path="/pg/login" element={<PgLoginPage />} />
		<Route path="/pg" element={<PgLoginGuard />}>
			<Route index element={<PgHomePage />} />
			<Route path=":code" element={<PgScanPage />} />
		</Route>
		<Route path="/desktop" element={<DesktopPage />} />
		<Route path="/share-to-friends" element={<ShareToFriendsPage />} />
		<Route path="/vip/statements/:token" element={<VipStatementPage />} />
		<Route path="/campaign/splash-2026" element={<Splash2026Page />} />
    
    <Route path="/wallpaper" element={<WallpaperProviders />}>
      {/* 台灣 LIFF 入口：liff 驗證 + 綁定判斷（連結 /wallpaper?from=wallpaper） */}
      <Route index element={<WallpaperLiffPage />} />
      {/* LIFF 索引頁（WallpaperLiffPage）外，其餘活動頁都套數據登入 Guard：
          台灣 LIFF 版走真實驗證、國際版走固定假值換 DATA_TOKEN */}
      <Route element={<WallpaperLogLoginGuard />}>
        {/* 國際版入口 + LIFF 綁定後的落地頁（連結 /wallpaper/home，?lang=en 顯示英文） */}
        <Route path="home" element={<WallpaperIntlPage />} />
        <Route element={<WallPaperLayoutPage />}>
          <Route path="start" element={<WallPaperStartPage />} />
          <Route path="text-setting" element={<WallpaperTextSettingPage />} />
          <Route path="download" element={<WallpaperDownloadPage />} />
        </Route>
        <Route path="view" element={<WallpaperViewPage />} />
        <Route path="share" element={<WallpaperSharePage />} />
      </Route>
    </Route>
		<Route path="/" element={<LoginGuard />}>
			<Route path="/ec" element={<EcLayout />}>
				<Route index element={<EcSeriesPage />} />
				<Route path="series/:id" element={<EcSeriesProductPage />} />
				<Route path="product/:id" element={<EcProductPage />} />
				<Route path="collectList" element={<EcCollectPage />} />
				<Route
					path="collectList/from-liff-share/:code"
					element={<EcCollectPage />}
				/>
			</Route>

			<Route path="/" element={<VisitorGuard />}>
				<Route path="/" element={<MgmGuard />}>
					<Route path="/nps" element={<NpsPage />} />
					<Route path="/campaign-coupon" element={<CampaignCouponPage />} />

					<Route path="/binding-sales" element={<BindingSalesPage />} />
					<Route element={<BindingActionGuard />}>
						<Route path="/thanks" element={<ThanksPage />} />
						<Route element={<AuthGuard />}>
							<Route index element={<ProfilePage />} />
							<Route path="/profile" element={<ProfilePage />} />
							<Route path="/binding" element={<BindingPage />} />
							<Route path="/coupon-wallet" element={<CouponWalletPage />} />
							<Route
								path="/tb-game-redirect"
								element={<TbGameRedirectPage />}
							/>

							{/* for testing */}
							<Route path="/profile/error/1" element={<ProfilePageError1 />} />
							<Route path="/profile/error/2" element={<ProfilePageError2 />} />
							<Route
								path="/coupon-wallet/empty"
								element={<CouponWalletPageEmpty />}
							/>
						</Route>
					</Route>

					<Route path="/logistics" element={<LogisticsPage />} />
					<Route path="/logisticsList" element={<LogisticsListPage />} />

					<Route path="/share-module" element={<ShareModulePage />} />
				</Route>
			</Route>
		</Route>
		<Route path="/line-oauth" element={<LineOAuthPage />} />

		{/* <Route path="/ec" element={<EcLoginGuard />}>
			<Route element={<EcLayout />}>
				<Route index element={<EcSeriesPage />} />
				<Route path="series/:id" element={<EcSeriesProductPage />} />
				<Route path="product/:id" element={<EcProductPage />} />
				<Route path="collectList" element={<EcCollectPage />} />
				<Route
					path="collectList/from-liff-share/:code"
					element={<EcCollectPage />}
				/>

			</Route>
		</Route> */}
	</Route>,
);

export default routes;
